import { BASE_PATH } from "..";
import type { BankGiroConfig } from "../../types/bankgiro";
import type { OnboardingPackage } from "../../types/package";
import type { SveaRequest } from "../../types/request";

export const selectPackage: SveaRequest = (applicationId: string, packageId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/package`,
	method: "POST",
	body: {
		packageId,
	},
});

// TODO not finished with the packageId?
export const removePackage: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/package`,
	method: "DELETE",
});

export const getAvailablePackages: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/package-v1`,
	method: "GET",
});

export const getSelectedPackage: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/selected-package`,
	method: "GET",
});

export const selectAddon: SveaRequest = (
	applicationId: string,
	addons: {
		productDefinitionId: OnboardingPackage["addons"][number]["definitionId"];
		productId: string;
	}[],
) => ({
	url: `${BASE_PATH}/application/${applicationId}/addon`,
	method: "POST",
	body: {
		addons,
	},
});

export const removeAddon: SveaRequest = (applicationId: string, addonIds: string[]) => ({
	url: `${BASE_PATH}/application/${applicationId}/addon`,
	method: "DELETE",
	body: {
		addons: addonIds,
	},
});

export const configureBankGiro: SveaRequest = (
	applicationId: string,
	configuration: BankGiroConfig,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/product/configure-bankgiro`,
	method: "POST",
	body: {
		configuration,
	},
});
